import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import BuildingIconSvg from './BuildingIconSvg'

const BuildingIcon = (props: IconProps): ReactElement => (
    <Icon component={BuildingIconSvg} {...props} />
)

export default BuildingIcon
